import React, { type Ref } from 'react';

import { type ControlProps } from '../../../../common/types';
import { StyledControl } from '../../../../common/ui/picker/styled';

// For LegacyRef type
type RefType = string & Ref<HTMLDivElement>;

export const Control = ({ children, innerProps, innerRef }: ControlProps) => {
	return (
		<StyledControl {...innerProps} ref={innerRef as RefType}>
			{children}
		</StyledControl>
	);
};
